import { render } from "./newUserForm.vue?vue&type=template&id=7454fca8&scoped=true"
import script from "./newUserForm.vue?vue&type=script&lang=js"
export * from "./newUserForm.vue?vue&type=script&lang=js"

import "./newUserForm.vue?vue&type=style&index=0&id=7454fca8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7454fca8"]])

export default __exports__